import React, {Component} from 'react'
import {message, Table, Button, Popconfirm, Form, Row, Col} from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';
import PackageModel from './packageModel';
import {toStrFixed} from '../../utills/subStringUtill'
import {getOrderShort, getPackages, savePackage, updatePackage, delPackage} from '../../api'
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthButton = authorizeBase(Button)

moment.locale('zh-cn');

class GoodsAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editVisiable: false,
            updateKey: '',
            action: '',
            count: 0,
            packageDataSource: [],
            origin: [],
            destination: [],
            readOnly: true,
        }
    }

    componentDidMount() {
        const orderId = this.props.location.state.orderId;
        this.orderShort(orderId);
        this.goods(orderId);
        this.setState({
            orderId: orderId
        })
    }

    orderShort = async (orderId) => {
        let result = await getOrderShort(orderId);
        if (result.code === 200) {
            let deliveryEstimateDt = result.data.deliveryEstimateDt ? result.data.deliveryEstimateDt.substr(0, 13) : '';
            let tradeDt = result.data.tradeDt ? result.data.tradeDt.substr(0, 13) : '';
            result.data.deliveryEstimateDt = deliveryEstimateDt;
            result.data.tradeDt = tradeDt;
            this.setState(result.data)
        } else {
            message.error(result.message)
        }
    };
    goods = async (orderId, page = 1, pageSize = 20) => {
        let result = await getPackages({orderId, pageNum: page, pageSize});
        if (result.code === 200) {
            if (result.data) {
                this.setState({
                    page,
                    pageSize,
                    total: result.data.total,
                    packageDataSource: result.data.rows,
                })
            }
        }
        else {
            message.error(result.message)
            return false;
        }

    };
    //显示弹窗
    showModal = () => {
        const count = this.state.count + 1;
        this.setState({
            editVisiable: true,
            updateKey: count,
            count: count,
            action: 'add'
        });
    };

    //显示弹窗
    editDataSource = (data) => {
        this.setState({
            editVisiable: true,
            updateKey: data.key,
            action: 'edit'
        });
        this.child.props.form.setFieldsValue(data);
    };
    //取消弹窗
    hideModal = () => {
        this.setState({
            editVisiable: false,
        })
    };
    //储存数据
    saveData = async (updateData) => {
        const {action, page, pageSize, orderId} = this.state;
        updateData.orderId = orderId;
        if (updateData.originalValue != null && updateData.pcsNumber != null) {
            updateData.originalTotalValue = toStrFixed(updateData.originalValue * updateData.pcsNumber);
        }
        if (action === 'add') {
            let result = await savePackage(updateData);
            if (result.code == 201) {
                this.goods(orderId, page, pageSize);
            } else {
                message.error(result.message);
            }
        } else {
            let result = await updatePackage(updateData);
            if (result.code == 200) {
                this.goods(orderId, page, pageSize);
            } else {
                message.error(result.message);
            }
        }
    };
    onChange = value => {
        console.log(value);
    };

    onRef = (ref) => {
        this.child = ref
    };

    handleDelete = async (id) => {
        const {orderId} = this.state;
        let result = await delPackage(id, orderId);
        if (result.code == 200) {
            this.goods(orderId);
        } else {
            message.error(result.message);
        }
    };

    render() {
        const {
            editVisiable, packageDataSource, updateKey
        } = this.state;
        const columns = [
            {
                title: '客户单号',
                dataIndex: 'platOrderNo',
            }, {
                title: '大区',
                dataIndex: 'area',
            }, {
                title: '客户简称',
                dataIndex: 'customerName',
            }, {
                title: '运单号',
                dataIndex: 'deliveryNo',
            }, {
                title: '随箱编号',
                dataIndex: 'boxNo',
            }, {
                title: '报关类型',
                dataIndex: 'declareType',
            }, {
                title: '箱数CTNS',
                dataIndex: 'num',
            }, {
                title: '总重量(Kg)',
                dataIndex: 'grossWeight',
            }, {
                title: '净重(Kg)',
                dataIndex: 'netWeight',
            }, {
                title: '尺寸(cm)',
                dataIndex: 'size',
            }, {
                title: '体积(CBM)',
                dataIndex: 'volume',
            }, {
                title: '品名(中文)',
                dataIndex: 'name',
            }, {
                title: '品名(英文)',
                dataIndex: 'nameEn',
            }, {
                title: 'HSCode',
                dataIndex: 'hscode',
            }, {
                title: '数量PCS',
                dataIndex: 'pcsNumber',
            }, {
                title: '单件净重',
                dataIndex: 'unitNetWeight',
            }, {
                title: '单价/币制Value unit',
                dataIndex: 'originalValue',
                render: (text, record) => {
                    if (text != null) {
                        return text + '/' + record.originalCurrency;
                    }
                }
            }, {
                title: '总价/币制Value & Currency',
                dataIndex: 'originalTotalValue',
                render: (text, record) => {
                    if (text != null) {
                        return text + '/' + record.originalCurrency;
                    }
                }
            }, {
                title: '成分(备注比例)',
                dataIndex: 'ingredient',
            }, {
                title: '用途',
                dataIndex: 'application',
            }, {
                title: '链接',
                dataIndex: 'picUrl',
            }, {
                title: '品牌',
                dataIndex: 'brand',
            }, {
                title: '操作',
                dataIndex: 'opt',
                fixed: 'right',
                width: 100,
                render: (text, record) => {
                    return (
                        <span> <a onClick={() => this.editDataSource(record)}
                                  style={{marginRight: 8}}>
                                        修改
                                    </a>
                            <Popconfirm title="是否确定删除?" onConfirm={() => this.handleDelete(record.id)}>
                            <a>删除</a>
                        </Popconfirm>
                        </span>
                    );
                }
            }
        ];
        return (
            <div className='order-info box-shadow padding-20'>
                <div className="head-title">
                    <div className='flex-between'>
                        <span className='title' style={{lineHeight: '32px'}}>订单详情</span>
                    </div>
                </div>
                <div className='order-info-content'>
                    <div className='order-space'>
                        <Form autoComplete='off'>
                            <div className="order-base-title">
                                基本信息
                            </div>
                            <div className="space-base-content">
                                <div className="base-info" style={{height: 'auto'}}>
                                    <Row>
                                        <Col span={12}>
                                            <span className='title'>起运地 : </span>
                                            <span
                                                className='address-detail'>{this.state.originCountry}&nbsp;{this.state.originCity}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>目的地:</span>
                                            <span
                                                className='address-detail'>{this.state.destinationCountry}&nbsp;{this.state.destinationCity}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>集装箱数 : </span>
                                            <span className='address-detail'>{this.state.containerNum}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>贸易时间:</span>
                                            <span className='address-detail'>{this.state.tradeDt}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>采购单号 : </span>
                                            <span className='address-detail'>{this.state.purchaseNo}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>发票编号:</span>
                                            <span className='address-detail'>{this.state.invNo}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>订单编号 : </span>
                                            <span className='address-detail'>{this.state.orderNo}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>货物包装:</span>
                                            <span className='address-detail'>{this.state.packageKind}</span>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className="order-base-title">
                                发货企业信息
                            </div>
                            <div className="space-base-content">
                                <div className="base-info" style={{height: 'auto'}}>
                                    <Row>
                                        <Col span={12}>
                                            <span className='title'>发货企业名称 : </span>
                                            <span className='address-detail'>{this.state.shipper}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>发货企业地址:</span>
                                            <span className='address-detail'>{this.state.shipperAddr}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>发货企业联系人 : </span>
                                            <span className='address-detail'>{this.state.shipperContact}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>发货企业联系方式:</span>
                                            <span className='address-detail'>{this.state.shipperTel}</span>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className="order-base-title">
                                境外收货方信息
                            </div>
                            <div className="space-base-content">
                                <div className="base-info" style={{height: 'auto'}}>
                                    <Row>
                                        <Col span={12}>
                                            <span className='title'>境外收货方名称 : </span>
                                            <span className='address-detail'>{this.state.consignee}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>境外收货方地址:</span>
                                            <span className='address-detail'>{this.state.consigneeAddr}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>境外收货方联系人 : </span>
                                            <span className='address-detail'>{this.state.consigneeContact}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>境外收货方联系方式:</span>
                                            <span className='address-detail'>{this.state.consigneeTel}</span>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className="order-base-title">
                                通知方信息
                            </div>
                            <div className="space-base-content">
                                <div className="base-info" style={{height: 'auto'}}>
                                    <Row>
                                        <Col span={12}>
                                            <span className='title'>通知方名称 : </span>
                                            <span className='address-detail'>{this.state.notifyParty}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>通知方地址:</span>
                                            <span className='address-detail'>{this.state.notifyPartyAddr}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>通知方联系人 : </span>
                                            <span className='address-detail'>{this.state.notifyPartyContact}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>通知方联系方式:</span>
                                            <span className='address-detail'>{this.state.notifyPartyTel}</span>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className="order-base-title">
                                仓库联系人信息
                            </div>
                            <div className="space-base-content">
                                <div className="base-info" style={{height: 'auto'}}>
                                    <Row>
                                        <Col span={12}>
                                            <span className='title'>仓库地址 : </span>
                                            <span className='address-detail'>{this.state.deliveryPlace}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>预计提货时间:</span>
                                            <span className='address-detail'>{this.state.deliveryEstimateDt}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>仓库联系人 : </span>
                                            <span className='address-detail'>{this.state.contact}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>仓库联系方式:</span>
                                            <span className='address-detail'>{this.state.contactTel}</span>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className="order-base-title">
                                商品信息
                            </div>
                            <div className="order-goods-content">
                                <Table columns={columns} bordered scroll={{x: 1300}} dataSource={packageDataSource}
                                       size="middle"
                                       pagination={{
                                           current: this.state.page,
                                           pageSize: this.state.pageSize ? this.state.pageSize : 20,
                                           total: this.state.total,
                                           pageSizeOptions: ['20', '50', '100'],
                                           showSizeChanger: true,
                                           onShowSizeChange: (page, pageSize) => {
                                               this.goods(this.state.orderId, page, pageSize);
                                           },
                                           onChange: (page, pageSize) => {
                                               this.goods(this.state.orderId, page, pageSize);
                                           },
                                           showTotal:(total)=>`共计 ${total} 条`,
                                       }}/>
                                <PackageModel
                                    onRef={this.onRef}
                                    editVisiable={ editVisiable }
                                    hideModal={ this.hideModal }
                                    saveData={ this.saveData }
                                    updateKey={ updateKey }
                                />
                                <div>
                                    <AuthButton authority="pack_edit:add" type="primary" onClick={this.showModal}
                                                style={{marginTop: '20px'}}>
                                        添加货物
                                    </AuthButton>&nbsp;
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        )
    }
}

const WrapGoodsAdd = Form.create()(GoodsAdd)
export default WrapGoodsAdd